<template>
  <div v-if="isNotificationOpen">
    <div
      class="notification-box relative ring-1 ring-gray-300 shadow hover:shadow-lg rounded"
    >
      <button
        type="button"
        class="absolute right-0 px-2 text-lg font-bold"
        @click="hideNotification()"
      >
        x
      </button>

      <router-link :to="{ name: action }" @click.native="hideNotification()">
        <div class="px-4 py-2 space-y-1">
          <div class="text-gray-dark">
            <p class="text-lg capitalize font-semibold">
              {{ title }}
            </p>
          </div>
          <div
            class="text-sm capitalize text-gray-dark flex items-center space-x-2"
          >
            <img
              class="inline object-cover w-6 h-6 rounded-full"
              src="/favicon.ico"
              alt="Profile image"
            />
            <p>{{ body }}</p>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
// import store from "@/store";
// import { mapActions } from "vuex";
import firebase from "firebase/app";
import "firebase/messaging";

export default {
  name: "NotificationBox",
  data() {
    return {
      title: "",
      body: "",
      action: "",
      isNotificationOpen: false,
      audio: new Audio(require("@/assets/audio/tone.mp3")),
    };
  },
  methods: {
    receiveMessage() {
      try {
        if (firebase.messaging.isSupported()) {
          firebase.app();
          var messaging = firebase.messaging();

          messaging.onMessage((payload) => {
            this.setNotificationData(payload.data);
            this.isNotificationOpen = true;

            this.audio && this.audio.play();
            this.audio.loop = true;

            // store.commit("setError", error);

            setTimeout(() => {
              this.isNotificationOpen = false;

              this.audio && this.audio.pause();
              this.audio.currentTime = 0;
            }, 1000);
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    setNotificationData(data) {
      this.title = data.title;
      this.body = data.body;
      this.action = data.action;
    },
    hideNotification() {
      this.isNotificationOpen = !this.isNotificationOpen;
      this.audio.pause();
      this.audio.currentTime = 0;
    },
  },
  created() {
    this.receiveMessage();
  },
};
</script>

<style scoped>
.notification-box {
  display: flex;
  position: absolute;
  right: 5px;
  bottom: 10px;
  width: 30%;
  height: 100px;
  background-color: #fff;
  z-index: 999;
}
@media only screen and (max-width: 420px) {
  .notification-box {
    bottom: 10px;
    width: 70%;
  }
}
@media only screen and (max-width: 768px) {
  .notification-box {
    width: 40%;
  }
}
</style>